import { css } from "@bdfx/fukit";
import trans from "../trans";
import { clip } from "../homepage/section";
import PricingFoxCtaBanner from '../app-components/pricingfox-cta-banner';
import AuditsLinks from '../app-components/audits-links';

export const Footer = () => {

    return (
    <StyledFooter className="section audit-footer npbreak">
        <div id="audit-end">
            <CtaWrapper>
                <div style={{textAlign: "center"}}>
                    <img alt="Pricing Fox logo" src="https://cdn.bdfx.cz/app/pf/img/logo.svg" width="300px" />
                </div>
                <p> {trans("pricing_result_footer")}</p>                
                <PricingFoxCtaBanner text={"Chci vyzkoušet!"} />
            </CtaWrapper>

            <AuditsLinks/>
        </div>
    </StyledFooter>
)}


export const StyledFooter = css("footer")({
    filter: "drop-shadow(0px 5px 10px rgba(0,0,0,0.3))",
    marginTop: "50px",
    fontSize: "1.4em",
    "> div": {
        marginTop: "-200px",
        paddingTop: "200px",
        paddingBottom: "100px",
        clipPath: clip,
        background: "#f6f6f6",
    },
})

const CtaWrapper = css("div")({
    display: "flex", 
    flexDirection: "column",
    gap: "1.1em", 
    justifyContent: "center", 
    marginInline: "auto",
    marginBlock: "2em 5em",
    maxWidth: "900px",
    " p" : {
        margin: 0,
    }
})

export default Footer;